import { BadgeSizeSM } from '../../../atoms/Badge/sizes/index.js';
import { LineHeights, FontSizes } from '../../../../foundation/typography/typography/index.js';
import { Spacings } from '../../../../foundation/spacings/spacings/index.js';
import { CornerRadius } from '../../../../foundation/cornerRadius/cornerRadius/index.js';
import { FontWeights } from '../../../../foundation/fonts/fonts/index.js';

const ControlSizesXL = {
    // Block
    blockHeight: 48,
    paddingHorizontal: Spacings.s12,
    paddingVertical: Spacings.s12,
    borderWidth: 1,
    borderRadiusButtonElement: CornerRadius.r24,
    borderRadiusControlElement: CornerRadius.r8,
    // Content
    contentHeight: 24,
    iconWidth: 24,
    iconHeight: 24,
    textPaddingHorizontal: Spacings.s4,
    textPaddingVertical: Spacings.s0,
    fontWeightButtonElements: FontWeights.semibold,
    fontWeightInputElements: FontWeights.medium,
    fontSize: FontSizes.s16,
    lineHeight: LineHeights.l24,
    // Badge
    badgeSize: BadgeSizeSM,
    spaceBetween: Spacings.s4,
    // Old
    height: 48,
    padding: Spacings.s16,
    borderRadius: CornerRadius.r8,
    gap: Spacings.s8,
    iconSize: 24,
};
const ControlSizesLG = {
    // Block
    blockHeight: 44,
    paddingHorizontal: Spacings.s10,
    paddingVertical: Spacings.s10,
    borderWidth: 1,
    borderRadiusButtonElement: CornerRadius.r22,
    borderRadiusControlElement: CornerRadius.r8,
    // Content
    contentHeight: 24,
    iconWidth: 24,
    iconHeight: 24,
    textPaddingHorizontal: Spacings.s4,
    textPaddingVertical: Spacings.s0,
    fontWeightButtonElements: FontWeights.semibold,
    fontWeightInputElements: FontWeights.medium,
    fontSize: FontSizes.s16,
    lineHeight: LineHeights.l24,
    // Badge
    badgeSize: BadgeSizeSM,
    spaceBetween: Spacings.s4,
    // Old
    height: 44,
    padding: Spacings.s12,
    borderRadius: CornerRadius.r8,
    gap: Spacings.s8,
    iconSize: 24,
};
const ControlSizesMD = {
    // Block
    blockHeight: 40,
    paddingHorizontal: Spacings.s10,
    paddingVertical: Spacings.s10,
    borderWidth: 1,
    borderRadiusButtonElement: CornerRadius.r20,
    borderRadiusControlElement: CornerRadius.r8,
    // Content
    contentHeight: 20,
    iconWidth: 20,
    iconHeight: 20,
    textPaddingHorizontal: Spacings.s2,
    textPaddingVertical: Spacings.s0,
    fontWeightButtonElements: FontWeights.semibold,
    fontWeightInputElements: FontWeights.medium,
    fontSize: FontSizes.s14,
    lineHeight: LineHeights.l20,
    // Badge
    badgeSize: BadgeSizeSM,
    spaceBetween: Spacings.s2,
    // Old
    height: 40,
    padding: Spacings.s12,
    borderRadius: CornerRadius.r8,
    gap: Spacings.s8,
    iconSize: 20,
};
const ControlSizesSM = {
    // Block
    blockHeight: 32,
    paddingHorizontal: Spacings.s6,
    paddingVertical: Spacings.s6,
    borderWidth: 1,
    borderRadiusButtonElement: CornerRadius.r16,
    borderRadiusControlElement: CornerRadius.r8,
    // Content
    contentHeight: 20,
    iconWidth: 20,
    iconHeight: 20,
    textPaddingHorizontal: Spacings.s2,
    textPaddingVertical: Spacings.s0,
    fontWeightButtonElements: FontWeights.semibold,
    fontWeightInputElements: FontWeights.medium,
    fontSize: FontSizes.s14,
    lineHeight: LineHeights.l20,
    // Badge
    badgeSize: BadgeSizeSM,
    spaceBetween: Spacings.s2,
    // Old
    height: 32,
    padding: Spacings.s8,
    borderRadius: CornerRadius.r8,
    gap: Spacings.s4,
    iconSize: 20,
};

export { ControlSizesLG, ControlSizesMD, ControlSizesSM, ControlSizesXL };
